import { useState, useEffect } from 'react';
import { Organization, USER_STATE_IN_ORGANIZATION } from '../../api/organization';
import {
  AccessTokenUser,
  OrganizationAccessRoles,
  getCurrentlyActiveOrganization,
  getUserFromAccessToken,
  getOrganizationAccess,
} from '../../common/auth';

export const useOrgRoleInfo = () => {
  const [activeOrganization, setActiveOrganization] = useState<Organization>();
  const [user, setUser] = useState<AccessTokenUser | undefined>(undefined);
  const [organizationRole, setOrganizationRole] = useState<OrganizationAccessRoles>();
  // Tracks whether the role lookup below has settled - success, `null`/no-match, or a
  // rejection - so callers can tell "still loading" apart from every real, settled
  // state that also leaves `organizationRole` as `undefined` (no active org, no
  // matching access row, or either promise rejecting). Do not infer settledness from
  // `organizationRole` itself; that was the bug this flag fixes.
  const [roleResolved, setRoleResolved] = useState(false);

  useEffect(() => {
    getCurrentlyActiveOrganization()
      .then((org) => {
        setActiveOrganization(org);
      })
      .catch((e) => console.log(e));

    void getUserFromAccessToken()
      .then((user) => {
        setUser(user);
        getOrganizationAccess()
          .then((access) => {
            const found = access?.OrganizationAccess.find(
              (ac) => ac.userId === user?.user.id
              // TODO: double check usersStateInOrganization flows
              // && ac.usersStateInOrganization === USER_STATE_IN_ORGANIZATION.ACTIVE
            )?.roleToAssume as OrganizationAccessRoles;
            setOrganizationRole(found);
            setRoleResolved(true);
          })
          .catch((e) => {
            console.log(e);
            setRoleResolved(true);
          });
      })
      .catch((e) => {
        // Guards the same dead end: without this, a rejection here means the role
        // lookup never even starts, and roleResolved would never flip to true.
        console.log(e);
        setRoleResolved(true);
      });
  }, []);
  //

  return {
    activeOrganization,
    user,
    organizationRole,
    roleResolved,
  };
};
